export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const EMPTY_CART = "EMPTY_CART";
export const UPDATE_BONUSE = "UPDATE_BONUSE";
export const CART_DELETE_ALL = "CART_DELETE_ALL";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_UPDATE_QUANTITIES = "CART_UPDATE_QUANTITIES";
